import '../styles/app.scss';
import './_images';
import './_fonts';
import WooQuantity from './components/WooQuantity';
import Campaign from './components/Campaign';
import P2pPagination from './components/P2pPagination';
import ScrolledBody from "./components/ScrolledBody";
import SearchForm from './components/SearchForm';
import ToggleAnimations from './components/ToggleAnimations';
import StickyElement from './components/StickyElement';
import MegaMenuScrolling from "./components/MegaMenuScrolling";
import MobileMenuDropdowns from "./components/MobileMenuDropdowns";
import CampaignGallery from "./components/CampaignGallery";
import ScrollTo from "./components/ScrollTo";
import MyAccount from "./components/MyAccount";
import { MyAccountDashboard } from "./components/MyAccountDashboard";
import { MyAccountSettings } from "./components/MyAccountSettings";
import {PdfReceiptGenerate} from "./components/PdfReceiptGenerate";
import {Ecards} from './components/Ecards';
import {Programs} from './components/Programs';
import RedirectingPopup from './components/RedirectingPopup';
import FeaturedImageRemove from './components/FeaturedImageRemove';
import { initSwitchTeamModal, shouldInitSwitchTeamModal } from './components/SwitchTeamModal';

document.addEventListener(
    'DOMContentLoaded',
    () => {
		const wooQuantity = new WooQuantity();
		wooQuantity.init();
		const campaign = new Campaign();
		campaign.init();
		const p2p_pagination = new P2pPagination();
		p2p_pagination.init();
		const search_form = new SearchForm();
		search_form.init();
		const toggle_animations = new ToggleAnimations();
		toggle_animations.init();
		const sticky_element = new StickyElement();
		sticky_element.init();
		const megamenu_scrolling = new MegaMenuScrolling();
		megamenu_scrolling.init();
		const mobileMenuDropdowns = new MobileMenuDropdowns();
		mobileMenuDropdowns.init();
		const campaignGallery = new CampaignGallery();
		campaignGallery.init();
		const scrollTo = new ScrollTo();
		scrollTo.init();
		const myAccount = new MyAccount();
		myAccount.init();
		const featuredImageRemove = new FeaturedImageRemove();
		featuredImageRemove.init();
		new MyAccountDashboard();
		new MyAccountSettings();

		new PdfReceiptGenerate();
        new Ecards()
        new Programs()
        new RedirectingPopup()

        if (shouldInitSwitchTeamModal()) {
            initSwitchTeamModal();
        }

		window.addEventListener("scroll" , ScrolledBody);
	},
	false
);
